import { Link } from "react-router-dom";

// Site-wide footer with legal links and copyright. Rendered at the bottom of
// the App tree so every route includes it.
const Footer = () => (
  <footer
    className="bg-mm-navy text-mm-parchment/85 mt-auto"
    data-testid="site-footer"
    role="contentinfo"
  >
    <div className="container mx-auto py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
      <div className="text-mm-parchment/70" data-testid="footer-copyright">
        © 2025 The Meadows Mindset. All rights reserved.
      </div>
      <nav className="flex items-center gap-5" aria-label="Footer legal">
        <Link
          to="/privacy"
          className="text-mm-gold font-bold hover:underline underline-offset-4"
          data-testid="footer-privacy-link"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms"
          className="text-mm-gold font-bold hover:underline underline-offset-4"
          data-testid="footer-terms-link"
        >
          Terms of Service
        </Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
